import { render, staticRenderFns } from "./FreeGift.vue?vue&type=template&id=163227b9"
import script from "./FreeGift.vue?vue&type=script&lang=js"
export * from "./FreeGift.vue?vue&type=script&lang=js"
import style0 from "./FreeGift.vue?vue&type=style&index=0&id=163227b9&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports